import { Component } from '@angular/core';
import { Views } from './enums/views.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Turbid Water';
  currentView = Views.PORTFOLIO;

  constructor() {
    const urlParts = location.href.split("?");
    const queryString = urlParts.length === 2 ? urlParts[1] : '';
    const queryParams = new URLSearchParams(queryString);
    this.currentView = queryParams.get("view") === Views.LINKS ? Views.LINKS : Views.PORTFOLIO;
  }

  public onCurrentViewClick( view: Views ): void {
    this.currentView = view;
  }
}
